import { render, staticRenderFns } from "./send-message-list-page.html?vue&type=template&id=0cdb5903&"
import script from "./send-message-list-page.ts?vue&type=script&lang=ts&"
export * from "./send-message-list-page.ts?vue&type=script&lang=ts&"
import style0 from "./send-message-list-page.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports